import { isEqual } from 'lodash';
import { compose, withState, lifecycle, renderNothing } from 'recompose';
import CreateCustomOverlay from 'utils/search/customOverlay';

export const initializeOverlay = ({
	setOverlay, google, map, overlay, ...props
}) => {
	if (map && google && !overlay) {
		const newOverlay = CreateCustomOverlay(google, map, props);
		setOverlay(newOverlay);
	}
};

export const enhance = compose(
	withState('overlay', 'setOverlay', null),
	lifecycle({
		componentDidMount() {
			initializeOverlay(this.props);
		},
		componentDidUpdate(prevProps) {
			if (!prevProps.google && !!this.props.google && !this.props.overlay) {
				initializeOverlay(this.props);
			} else if (
				this.props.overlay &&
				!isEqual(prevProps.selected, this.props.selected)
			) {
				this.props.overlay.update(this.props);
			}
		},
		componentWillUnmount() {
			this.props.overlay.remove();
		}
	})
);

export default enhance(renderNothing());
